export const environment = {
  production: false,
  mapboxToken: 'pk.eyJ1IjoicmFmYXRnZyIsImEiOiJjbTk5emdrNzIwMDQ2MnNxMTVoenhmN3ZuIn0.2IrILqa0qj1FSPSdNsvDUg',
  apiUrl: 'https://dev.westetics.com.br',
  intercomAppId: 'sw9pznhs'
};